'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { cloneElement, Component } from 'react';
import classNames from 'classnames';
import devLogger from 'react-utils/devLogger';
import validHref from '../utils/propTypes/validHref';
import UIFlex from '../layout/UIFlex';
import UILink from '../link/UILink';
import UIClickable from '../button/UIClickable';
import { FOCUSABLE as FOCUSABLE_SELECTOR } from '../constants/Selectors';
import { hidden } from '../utils/propTypes/decorators';
import { warnIfFragment } from '../utils/devWarnings';
import * as CustomRenderer from '../utils/propTypes/customRenderer';
import HoverProvider from '../providers/HoverProvider';
import FocusProvider from '../providers/FocusProvider';
var USE_CLASSES = {
  default: '',
  'full-card': 'private-hoverlay--full-card',
  'bottom-half-card': 'private-hoverlay--bottom-half-card'
};

var UIHoverlay = /*#__PURE__*/function (_Component) {
  _inherits(UIHoverlay, _Component);

  function UIHoverlay() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UIHoverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UIHoverlay)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hasTabbableContent: false
    };

    _this.refCallback = function (el) {
      if (!el) return;
      var hasTabbableContent = el.querySelector(FOCUSABLE_SELECTOR);

      _this.setState({
        hasTabbableContent: hasTabbableContent
      });
    };

    return _this;
  }

  _createClass(UIHoverlay, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _blur = _this$props._blur,
          className = _this$props.className,
          children = _this$props.children,
          __focused = _this$props.focused,
          foregroundContent = _this$props.foregroundContent,
          __hovered = _this$props.hovered,
          href = _this$props.href,
          linkComponent = _this$props.linkComponent,
          onClick = _this$props.onClick,
          overlayClassName = _this$props.overlayClassName,
          tabIndex = _this$props.tabIndex,
          use = _this$props.use,
          rest = _objectWithoutProperties(_this$props, ["_blur", "className", "children", "focused", "foregroundContent", "hovered", "href", "linkComponent", "onClick", "overlayClassName", "tabIndex", "use"]);

      var hasTabbableContent = this.state.hasTabbableContent;

      if (process.env.NODE_ENV !== 'production') {
        if (href && onClick) {
          devLogger.warn({
            message: 'UIHoverlay: Cannot have both onClick and href props.'
          });
        }
      }

      warnIfFragment(children, UIHoverlay.displayName);
      return React.createElement(HoverProvider, this.props, function (hoverProviderProps) {
        return React.createElement(FocusProvider, _this2.props, function (focusProviderProps) {
          var hovered = hoverProviderProps.hovered,
              hoverProviderRestProps = _objectWithoutProperties(hoverProviderProps, ["hovered"]);

          var focused = focusProviderProps.focused,
              focusProviderRestProps = _objectWithoutProperties(focusProviderProps, ["focused"]);

          var wrappedForegroundContent = foregroundContent == null ? null : React.createElement("div", {
            className: classNames("uiOverlay-backdrop private-hoverlay__overlay private-overlay--contextual", overlayClassName, (href || onClick) && 'private-hoverlay__overlay--clickable', focused && 'private-hoverlay__overlay--focused', hovered && 'private-hoverlay__overlay--hovered')
          }, React.createElement(UIFlex, {
            align: "stretch",
            direction: "column",
            justify: "start",
            className: "private-overlay__overlay-content private-hoverlay__foreground-content"
          }, foregroundContent));
          var renderedOverlay = React.createElement("span", null, wrappedForegroundContent, React.createElement("div", {
            className: 'private-hoverlay__children' + (_blur ? " private-hoverlay__children--blur private-hoverlay--blur" : "")
          }, cloneElement(children, {
            className: classNames('private-hoverlay__child', children.props.className)
          })));
          var renderedHoverlay;

          if (href) {
            renderedHoverlay = CustomRenderer.render(linkComponent, {
              children: renderedOverlay,
              className: 'display-block',
              href: href,
              use: 'unstyled'
            });
          } else if (onClick) {
            renderedHoverlay = React.createElement(UIClickable, {
              className: "private-hoverlay__button",
              onClick: onClick
            }, renderedOverlay);
          } else {
            renderedHoverlay = renderedOverlay;
          }

          var computedTabIndex;

          if (tabIndex != null) {
            computedTabIndex = tabIndex;
          } else {
            computedTabIndex = hasTabbableContent ? null : 0;
          }

          return React.createElement("div", Object.assign({}, rest, hoverProviderRestProps, focusProviderRestProps, {
            className: classNames(className, 'private-hoverlay', USE_CLASSES[use], use === 'full-card' && 'is--module'),
            ref: _this2.refCallback,
            tabIndex: computedTabIndex
          }), renderedHoverlay);
        });
      });
    }
  }]);

  return UIHoverlay;
}(Component);

UIHoverlay.propTypes = {
  _blur: PropTypes.bool,
  children: PropTypes.element,
  focused: hidden(PropTypes.bool),
  foregroundContent: PropTypes.node,
  hovered: PropTypes.bool,
  href: PropTypes.oneOfType([validHref]),
  linkComponent: CustomRenderer.propType,
  overlayClassName: PropTypes.string,
  use: PropTypes.oneOf(Object.keys(USE_CLASSES))
};
UIHoverlay.defaultProps = {
  _blur: true,
  linkComponent: UILink,
  use: 'default'
};
UIHoverlay.displayName = 'UIHoverlay';
export default UIHoverlay;